export default __webpack_public_path__ + "static/media/logo.35a8d555.svg";